<template>
  <v-layout justify-center fill-height row v-if="loyaltyReward != null">
    <v-flex xs12>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 ms12>
            <v-card-title dense primary-title class="headline primary">
              <v-layout row align-center>
                <v-btn dark icon @click="$router.push('/settings/loyalty_rewards/')">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <span
                  class="title font-weight-light white--text"
                >Update {{ external ? "External" : "Internal" }} Reward</span>
              </v-layout>
            </v-card-title>
          </v-flex>
          <v-flex xs12 md12 px-2 pt-2>
            <LoyaltyRewardForm
              ref="loyaltyRewardForm"
              :loyaltyReward="loyaltyReward"
              @validityChange="updateLoyaltyRewardFormValidity($event)"
              @imageInput="handleImageInput"
            ></LoyaltyRewardForm>
          </v-flex>
          <v-flex xs12 md12 v-if="!external">
            <PromotionForm
              ref="PromotionForm"
              :disabled="false"
              :promotion="loyaltyReward.promotion"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 v-if="external">
            <ExternalPromotionForm
              ref="ExternalPromotionForm"
              :disabled="false"
              :promotion="loyaltyReward.external_promotion"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 pt-2 pb-2>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none">Submit</v-btn>
            </v-layout>
          </v-flex>
          <v-flex style="width:100%;" xs12></v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import PromotionForm from "@/components/settings/promotions/PromotionForm.vue";
import LoyaltyRewardForm from "@/components/settings/loyalty/LoyaltyRewardForm.vue";
import ExternalPromotionForm from "@/components/settings/loyalty/ExternalPromotionForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "edit_loyalty_reward",
  components: {
    PromotionForm,
    ExternalPromotionForm,
    LoyaltyRewardForm
  },
  computed: {
    external: function() {
      return this.loyaltyReward.external_promotion != null;
    }
  },
  data: function() {
    return {
      loyaltyReward: null,
      errors: {},
      promotionFormValid: true,
      loyaltyRewardFormValid: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  mounted: function() {
    this.getLoyaltyReward();
  },
  methods: {
    getLoyaltyReward: async function() {
      console.log("loyalty reward");

      this.disabled = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/settings/loyalty_point_reward/${this.$route.params.id}/get`;

      console.log("Getting loyalty reward");

      axios
        .get(url)
        .then(function(response) {
          if (!response.error) {
            if (response.data.loyalty_point_reward) {
              self.disabled = false;
              self.loyaltyReward = response.data.loyalty_point_reward;

              //Stop current codes from being deletable
              if (self.loyaltyReward.promotion != null) {
                self.loyaltyReward.promotion.discount_fixed =
                  self.loyaltyReward.promotion.discount_fixed / 100;
                self.loyaltyReward.promotion.max_booking_cost_with_discount =
                  self.loyaltyReward.promotion.max_booking_cost_with_discount /
                  100;

                let fixedCodes = [];
                self.loyaltyReward.promotion.codes.forEach(function(code) {
                  fixedCodes.push({
                    code: code,
                    new: false
                  });
                });

                self.loyaltyReward.promotion.codes = fixedCodes;
              }
            }
          } else {
            console.log(response.error);
            self.rideType = {};
            self.tariff = {};
            self.showSnackbar(
              "Error fetching loyalty reward: " + response.error,
              "error"
            );
          }
          self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          self.rideType = {};
          self.tariff = {};
          self.showSnackbar(error, "error");
          self.loading = false;
        });
    },
    submit: async function() {
      console.log(this.promotionFormValid);
      console.log(this.loyaltyRewardFormValid);

      this.$refs.loyaltyRewardForm.validateForm();

      if (this.promotionFormValid && this.loyaltyRewardFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/loyalty_point_reward/${this.loyaltyReward.id}/update`;

        var data = Object.assign({}, this.loyaltyReward);

        if (this.loyaltyReward.promotion != null) {
          let promotionToSend = Object.assign({}, this.loyaltyReward.promotion);
          let codesToSend = [];
          promotionToSend.codes.forEach(function(promocode) {
            if (promocode.new != false) {
              codesToSend.push(promocode.code);
            }
          });
          promotionToSend.codes = codesToSend;

          data.promotion = promotionToSend;

          data.promotion.name = encodeURI(data.promotion.name);
          data.promotion.description = encodeURI(data.promotion.description);
          data.promotion.user_description = encodeURI(
            data.promotion.user_description
          );
        } else {
          var externalPromotion = Object.assign(
            {},
            this.loyaltyReward.external_promotion
          );

          externalPromotion.name = encodeURI(externalPromotion.name);
          externalPromotion.description = encodeURI(
            externalPromotion.description
          );
          externalPromotion.user_description = encodeURI(
            externalPromotion.user_description
          );

          data.external_promotion = externalPromotion;
        }

        console.log(data);

        if (this.external) {
          delete data.promotion;
        } else {
          delete data.external_promotion;
        }

        console.log(data.image);

        axios({
          url: url,
          method: "post",
          data: { loyalty_point_reward: data },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error adding reward, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding reward: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              self.$router.push("/settings/loyalty_rewards/");
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.PromotionForm.validateForm();
      }
    },
    handleImageInput: function(file) {
      console.log(file);
      this.loyaltyReward.image = file;
    },
    updateFormValidity: function(value) {
      this.promotionFormValid = value;
    },
    updateLoyaltyRewardFormValidity: function(value) {
      this.loyaltyRewardFormValid = value;
    }
  }
};
</script>